<template>
  <v-container>
    <v-content>
      <div id="chart"></div>
<div>2</div>
      <div id="chart2"></div>
      <svg>
        
      </svg>
    </v-content>
  </v-container>
</template>

<script>
import * as d3 from "d3";

var chartOptions = {
  height: 300,
  width: 600,
}

var svg1, svg2

var xScale2, yScale2;
var xScale1, yScale1;

// function printPointOnChart1(graphX, graphY){
//     console.log('onChart1 X value is : ' + xScale1(graphX))
//     console.log('onChart1 Y value is : ' + yScale1(graphY))
// }

// function printPointOnChart2(graphX, graphY){
//     console.log('onChart2 X value is : ' + xScale2(graphX))
//     console.log('onChart2 Y value is : ' + yScale2(graphY))
// }

function drawCircle(xx, yy, r, svg, xScale, yScale){
    svg.selectAll('.click-circle').remove()
    svg.selectAll('.click-text').remove()
    
    console.log(svg1)
    console.log(svg2)

    console.log(xScale1)
    console.log(yScale1)
    console.log(xScale2)
    console.log(yScale2)

    var graphX = xScale.invert(xx) 
    var graphY = yScale.invert(yy)


// draw to 2. chart, find intersect point
    var xPos = xx
    
    // svg2.append('circle')
    //     .attr('cx', xScale2(graphX))
    //     .attr('cy', yScale2(150))
    //     .attr('r', r)

    var pathLength = d3.select('.path2').node().getTotalLength();
    // console.log(pathLength)

    var x = xPos;
      var beginning = x,
      end = pathLength,
      target;
      var pos;
    while (true) {        

      target = Math.floor((beginning + end) / 2);
      pos = d3.select('.path2').node().getPointAtLength(target);
      if ((target === end || target === beginning) && pos.x !== x) {
        break;
      }
      if (pos.x > x) end = target;
      else if (pos.x < x) beginning = target;
      else break; //position found
    }

    console.log("x and y coordinate where vertical line intersects graph: " + [pos.x, pos.y]);
    console.log("data where vertical line intersects graph: " + [xScale2.invert(pos.x), yScale2.invert(pos.y)]);

    svg2.select('circle').attr("opacity", 1)
      .attr("cx", x)
      .attr("cy", pos.y)
      .attr("r", r);



// end of  draw to 2
        

    console.log('graph x,y : ' + graphX+ "," + graphY)

    svg.append('circle')
      .attr('class', 'click-circle')
      // .transition()
      // .duration(500)
      .attr('cx', xx)
      .attr('cy', yy)
      .attr('r', r)

    svg.append('text')
        .attr('class', 'click-text')
        .attr('x', xx + 10)
        .attr('y', yy + 10)
        .text(graphY)

        //printPointOnChart1(graphX, graphY)
  }




function draw2() {
  // set the dimensions and margins of the graph
  var margin = { top: 10, right: 40, bottom: 30, left: 30 },
    width = chartOptions.width - margin.left - margin.right,
    height = chartOptions.height - margin.top - margin.bottom;

  // create data
  var data = [
    { x: 0, y: 100 },
    { x: 10, y: 50 },
    { x: 25, y: 40 },
    { x: 45, y: 10 },
    { x: 200, y: 200 },
    { x: 220, y: 40 },
    { x: 400, y: 400 }
  ];
 
  // create svg element:
  var svg = d3
    .select("#chart2")
    .append("svg")
    
    .attr("viewBox", `0 0 ${ width + margin.left + margin.right } ${ height + margin.top + margin.bottom }`)
    //.attr("width", width + margin.left + margin.right)
    //.attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var x = d3
    .scaleLinear()
    .domain([0, 600])
    .range([0, width]);

 
  var y = d3
    .scaleLinear()
    .domain([0, 400])
    .range([height, 0]);

xScale2 = x
yScale2 = y
 
  // prepare a helper function
  var lineFunc = d3
    .line()
    .curve( d3.curveMonotoneX )
    .x(function(d) {
      return x(d.x);
    })
    .y(function(d) {
      return y(d.y);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))

  

   

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "path2")
    .attr("d", lineFunc(data))
    .attr("stroke", "black")
    .attr("fill", "none")
    .attr('stroke-width', 3)

    svg.append('circle').attr("opacity", 0)
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", 6);



  svg.selectAll('path')
  .on("mouseover", function() {
    d3.select(this)
    .style("stroke", "orange")
    // .attr('stroke-width', 6)
  })
  .on("mouseout", function() {
    d3.select(this)
    .style("stroke", "black")
    // .attr('stroke-width', 3)
    // console.log(this);
  })
  .on("click", function() {
    var coords = d3.mouse(this)
    console.log(coords)
    drawCircle(coords[0], coords[1], 6, svg, x, y)
    // d3.select(this)
    // .style("stroke", "black")
    // .attr('stroke-width', 3)
    // console.log(this);
  })










  // svg
  //   .selectAll("whatever")
  //   .data(data)
  //   .enter()
  //   .append("circle")
  //   .attr("cx", function(d) {
  //     return x(d.x);
  //   })
  //   .attr("cy", function(d) {
  //     return y(d.y);
  //   })
  //   .attr("r", 7);

  // svg.selectAll("circle")
  // .on("mouseover", function() {
  //   d3.select(this).style("fill", "orange");
  //   // console.log(this);
  // })
  // .on("mouseout", function() {
  //   d3.select(this).style("fill", "black");
  //   // console.log(this);
  // })
  




svg2 = svg



}



function draw() {
  // set the dimensions and margins of the graph
  var margin = { top: 10, right: 40, bottom: 30, left: 30 },
    width = chartOptions.width - margin.left - margin.right,
    height = chartOptions.height - margin.top - margin.bottom;

  // create data
  var data = [
    { x: 0, y: 20 },
    { x: 150, y: 150 },
    { x: 300, y: 100 },
    { x: 450, y: 20 },
    { x: 600, y: 130 }
  ];
 

  // create svg element:
  var svg = d3
    .select("#chart")
    .append("svg")
    .attr("viewBox", `0 0 ${ width + margin.left + margin.right } ${ height + margin.top + margin.bottom }`)
    
    // .attr("width", width + margin.left + margin.right)
    // .attr("height", height + margin.top + margin.bottom)
    // translate this svg element to leave some margin.
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var x = d3
    .scaleLinear()
    .domain([0, 600])
    .range([0, width]);

 
  var y = d3
    .scaleLinear()
    .domain([0, 150])
    .range([height, 0]);

xScale1 = x
yScale1 = y
 
  // prepare a helper function
  var lineFunc = d3
    .line()
    .curve( d3.curveMonotoneX )
    .x(function(d) {
      return x(d.x);
    })
    .y(function(d) {
      return y(d.y);
    });

  svg
    .append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  svg.append("g").call(d3.axisLeft(y));

  // svg.call(d3.axisLeft(y))

 

   

  // Add the path using this helper function
  svg
    .append("path")
    .attr("class", "path1")
    .attr("d", lineFunc(data))
    .attr("stroke", "black")
    .attr("fill", "none")
    .attr('stroke-width', 3)



  svg.append('circle').attr("opacity", 0)
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", 6);

  svg.selectAll('path')
  .on("mouseover", function() {
    d3.select(this)
    .style("stroke", "orange")
    // .attr('stroke-width', 6)
  })
  .on("mouseout", function() {
    d3.select(this)
    .style("stroke", "black")
    // .attr('stroke-width', 3)
    // console.log(this);
  })
  .on("click", function() {
    var coords = d3.mouse(this)
    console.log(coords)
    drawCircle(coords[0], coords[1], 6, svg, x, y)
    
    // d3.select(this)
    // .style("stroke", "black")
    // .attr('stroke-width', 3)
    // console.log(this);
  })










  // svg
  //   .selectAll("whatever")
  //   .data(data)
  //   .enter()
  //   .append("circle")
  //   .attr("cx", function(d) {
  //     return x(d.x);
  //   })
  //   .attr("cy", function(d) {
  //     return y(d.y);
  //   })
  //   .attr("r", 7);

  // svg.selectAll("circle")
  // .on("mouseover", function() {
  //   d3.select(this).style("fill", "orange");
  //   // console.log(this);
  // })
  // .on("mouseout", function() {
  //   d3.select(this).style("fill", "black");
  //   // console.log(this);
  // })
  





svg1 = svg


}


export default {
  name: "HelloWorld",

  data: () => ({}),

  mounted: function() {
    draw();
    draw2();

  }
};
</script>
